import { GLOBAL_EVENTS } from "../../constants/global";
import { SOCKET_EVENTS } from "../../socket/Socket";
import { getAllUsers } from "../../socket/userUtil";
import { filterFriendsData } from "../Chat/chatData";

class FriendsHelper {

  constructor({ model, socket }) {
    this.socket = socket;
    this.model = model;
    this.model.friendsHelper = this;
    console.log("FriendsHelper", this.socket);

    this.friendsList;
    this.offlineFriends = [];
    this.onlineFriends = [];
    this.friendsMap = {};
    this.onlineFriendsMap = {};

    const onOnlineFriendsLoaded = () => {
      this.onlineFriends = [];
      this.offlineFriends = [];
      this.onlineFriendsMap = {};

      const onlineFriends = this.socket.getOnlineFriends();
      onlineFriends.map(item => {
        this.onlineFriendsMap[item.userId] = item;
      })

      this.onlineUsers = this.socket.getUsers();
      this.friendsList.forEach(item => {
        if (!this.onlineFriendsMap[Number(item.id)]) {
          this.offlineFriends.push(item);
        } else {
          // this.onlineFriends.push(item)
          this.onlineFriends.push({ ...this.onlineFriendsMap[Number(item.id)], status: this.friendsMap[item.id].status })
        }
      });
      this.model.onFriendsSet({ online: this.onlineFriends, offline: this.offlineFriends })
    }

    const onFriendsLoaded = (response) => {
      this.model.removeAllNotifications();
      ///api
      if (!response.data) {
        return;
      }
      this.model.socket.removeEventListener(SOCKET_EVENTS.ONLINE_FRIENDS_LOADED, onOnlineFriendsLoaded);
      this.friendsMap = {};
      const _res = response.data || [];
      const ids = [];
      _res.map(item => {
        ids.push(Number(item.id));
        this.friendsMap[item.id] = item;
      });
      this.friendsList = _res;
      filterFriendsData(this.friendsList);
      this.model.friendsMap = this.friendsMap;
      this.model.dispatchEvent({ type: GLOBAL_EVENTS.FRIENDS_LOADED, response })

      const onSocketReady = () => {
        this.model.socket.addEventListener(SOCKET_EVENTS.ONLINE_FRIENDS_LOADED, onOnlineFriendsLoaded);
        this.model.socket.removeEventListener(SOCKET_EVENTS.INIT_USERS, onSocketReady);
        this.model.socket.requestFriendsInfo(ids);

      }
      if (!this.model.socket.initialised) {
        this.model.socket.addEventListener(SOCKET_EVENTS.INIT_USERS, onSocketReady);
      } else {
        this.model.socket.addEventListener(SOCKET_EVENTS.ONLINE_FRIENDS_LOADED, onOnlineFriendsLoaded);
        this.model.socket.requestFriendsInfo(ids);
      }
    }

    this.refreshFriendsList = () => {
      if (!this.model.config.isGuest) {
        this.model.worldFetcher.getFriendsList(onFriendsLoaded);
      }
    }
    this.refreshFriendsList();
    ///automation
    this.model.addEventListener(SOCKET_EVENTS.SOCKET_CONNECT_SUCCESS, () => {
      // this.model.info('success', "Loading friends...");
    });
    this.model.addEventListener(GLOBAL_EVENTS.SESSION_CONNECTED, this.refreshFriendsList);
    this.socket.addEventListener(SOCKET_EVENTS.USER_DISCONNECTED, this.refreshFriendsList);
  }

}

export { FriendsHelper }